import { api_base_url } from "../../../constants";
import { getAppLocale } from "../../../utils/app-locale";
import { appConfiguration } from "../../../utils/app-starter";
import { API_INSTANCE } from "../../../utils/service-http";


export function getSizedServicePlans (softwareSelection, licenseModel, softwareLicenses) {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

  return API_INSTANCE.post(`${api_base_url}/size-service-plan?locale=${getAppLocale()}${mainOverrideString}`, {
    softwareSelection,
    licenseModel,
    softwareLicenses
  }).then((success) => {
    return success.data.payload;
  }).catch((error) => {
    throw error;
  });
}
